import type { DialogProps } from "@mui/material";

// Wraps a Dialog onClose handler so backdrop (outside) clicks do not close the dialog.

export function withoutBackdropClose(
  onClose?: DialogProps["onClose"],
): DialogProps["onClose"] {
  return (event, reason) => {
    if (reason === "backdropClick") return;
    onClose?.(event, reason);
  };
}
